import { Route, Routes } from "react-router"
import { Navigate } from "react-router-dom"
import Home from "../pages/Home.jsx"
import Account from "../pages/Account.jsx"
import Login from "../pages/Login.jsx"
import ProtectedRoute from "../components/ProtectedRoute.jsx"
import Register from "../pages/Register.jsx"
import Business from "../pages/Business.jsx"
import Checkout from "../pages/Checkout.jsx"
import NotFound from "../pages/NotFound.jsx"
import FAQ from "../pages/FAQ.jsx"
import Terms from "../pages/Terms.jsx"
import Privacy from "../pages/Privacy.jsx"
import Withdrawal from "../pages/Withdrawal.jsx"


const MainRoutes = () => {
  return (
    <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/register' element={<Register/>}/>
        <Route path='/:usuarioEmpresa' element={<Business/>}/>
        <Route path='/preguntas-frecuentes' element={<FAQ/>}/>
        <Route path='/terminos-y-condiciones' element={<Terms/>}/>
        <Route path='/politicas-de-privacidad' element={<Privacy
        />}/>
        <Route path='/arrepentimiento' element={<Withdrawal/>}/>


        <Route path='/cuenta' element={

          <ProtectedRoute redirectTo={"/login"}>
            <Account/>
          </ProtectedRoute>
          }>
        </Route> 

        {/* La configuración ahora vive en las secciones del panel. */}
        <Route path='/cuenta/configuracion' element={<Navigate to="/cuenta#negocio" replace/>}/> 

        <Route path='/suscripcion' element={

          <ProtectedRoute redirectTo={"/login"}>
            <Checkout/>
          </ProtectedRoute>
          }>
        </Route> 

        <Route path='*' element={<NotFound></NotFound>}/>
        <Route path='/not-found' element={<NotFound></NotFound>}/>

    </Routes>
  )
}

export default MainRoutes